import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Auth } from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import { Header as LegoHeader, Nav, NavItem } from '@kambria/kambria-lego';

import { linkProvider } from 'helpers/cognito.lib';
import { fetchUser } from 'modules/user.reducer';

import logo from 'static/svg/logo.svg';

const NAV = [
  { url: '/tools', title: 'Tools', exact: false },
]

class Header extends React.Component {

  componentDidMount() {
    this.props.fetchUser().then(re => {
      // Nothing
    }).catch(er => {
      return console.log(er);
    });
    this.listenAuth();
  }

  /**
   * Listen authentication events
   * It should be call in constructor function
   */
  listenAuth = () => {
    let cognitoAuth = window.cognitoAuth;
    const { history } = this.props;
    if (cognitoAuth) {
      let listener = (args) => {
        let { event, data } = args.payload;
        switch (event) {
          case 'signIn':
            this.props.fetchUser();
            break;
          case 'federatedSignIn':
            linkProvider({ authorization: data.accessToken, provider: data.provider }, er => {
              if (er) return console.error(er);
              cognitoAuth.IdentityProvider = data.provider;
              return cognitoAuth.getSession();
            });
            break;
          case 'federatedSignInFailure':
            break;
          case 'returnSession':
            // Return to location before sign in
            history.push(localStorage.getItem('pathBeforeSignIn') || '');
            break;
          case 'signUp':
            break;
          case 'signOut':
            break;
          case 'signIn_failure':
            break;
          case 'configured':
            break;
          default:
            break;
        }
      };

      Hub.listen('auth', listener);
      let curUrl = window.location.href;
      cognitoAuth.parseCognitoWebResponse(curUrl);
    }
  }

  logout = async () => {
    localStorage.removeItem('pathBeforeSignIn');
    await Auth.signOut();
    return window.cognitoAuth.signOut();
  }

  login = () => {
    return this.props.history.push(`/auth`);
  }

  render() {
    const { user } = this.props;
    const isLoggedIn = user && user.authenticated;

    return <LegoHeader logo={{ image: logo, url: 'https://kambria.io' }}>
      <Nav>
        {NAV.map((item, index) => <NavItem key={index} item={item} />)}
        {isLoggedIn ? <li key="logout">
          <button className='btn btn-secondary btn-sm' onClick={this.logout}>Logout</button>
        </li> : <li key="login">
          <button className='btn btn-secondary btn-sm' onClick={this.login}>Login / Register</button>
        </li>}
      </Nav>
    </LegoHeader>
  }
}

const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUser
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header));